__webpack_require__.p = "https://ppc.atlassian.com/assets/";